<template>
  <div class="matrix-card-container">
    <el-row :gutter="20">
      <el-col v-for="(item, idx) in column" :key="item.label" :span="item.span || span">
        <el-card>
          <div class="matrix-card">
            <div class="matrix-card__title">{{item.label}}</div>
            <div class="matrix-card__content" v-if="data[idx]">
              <template v-if="item.isNumber">
                <avue-count-up :end="data[idx].value" :decimals="decimals"></avue-count-up>
                <span>{{item.unit}}</span>
              </template>
              <template v-else>
                {{ data[idx].value }}
              </template>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "matrix-card-group",
  props: {
    // 栅格占据的列数
    span: {
      type: Number,
      default: 8
    },
    // {label, span: 栅格占据的列数, isNumber: 是否数字类型, unit: 单位, }
    column: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => []
    },
    // 支持几位小数
    decimals: {
      type: Number,
      default: 0
    }
  },
  created() {
    console.info(this.column, "🚀 ~ method:created, line:49 ====== this.column")
  }
}
</script>

<style lang="scss" scoped>
  .matrix-card-container {
    padding: 10px 0;

    .matrix-card {
      padding: 15px;

      &__title {
        color: #a7a7a7;
        font-size: 12px;
      }

      &__content {
        color: #000;
        height: 35px;
        font-size: 24px;
        font-weight: bold;
        line-height: 37px;
      }
    }
  }
</style>
